import { useState } from "react";
import { comics } from "@/mocks/comics";

export default function Featured() {
  const [active, setActive] = useState(comics[0].id);

  const current = comics.find((c) => c.id === active) ?? comics[0];

  return (
    <section id="featured" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary-600">
              <i className="ri-star-fill"></i> 编辑精选
            </span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">
              热门连载专题
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              点击切换，查看本期推荐的连载作品与最新话进度，一键直达追更。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_1.2fr] lg:items-stretch">
          <div className="flex flex-col gap-3">
            {comics.slice(0, 6).map((c) => (
              <button
                key={c.id}
                type="button"
                onClick={() => setActive(c.id)}
                className={`flex items-center gap-3 rounded-lg border p-3 text-left transition-colors ${
                  active === c.id
                    ? "border-primary-400 bg-primary-50"
                    : "border-background-200 bg-background-100 hover:border-primary-300"
                }`}
              >
                <img
                  src={c.cover}
                  alt={`${c.title}专题封面`}
                  className="h-16 w-12 shrink-0 rounded object-cover object-top"
                />
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-bold text-foreground-950">{c.title}</h3>
                  <p className="mt-0.5 text-xs text-foreground-500">{c.category} · {c.author}</p>
                  <p className="mt-1 truncate text-xs text-primary-600">{c.latestChapter}</p>
                </div>
                <i
                  className={`ri-arrow-right-s-line text-xl ${
                    active === c.id ? "text-primary-600" : "text-foreground-400"
                  }`}
                ></i>
              </button>
            ))}
          </div>

          <article className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src={current.cover}
                alt={`${current.title}热门连载大图`}
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <span className="absolute left-4 top-4 rounded-md bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                本周精选
              </span>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <h3 className="font-heading text-2xl text-background-50">{current.title}</h3>
                <p className="mt-1 text-sm text-background-100/90">
                  {current.author} · {current.category} · {current.chapters} 话
                </p>
              </div>
            </div>
            <div className="p-5">
              <div className="flex flex-wrap gap-1.5">
                {current.tags.map((t) => (
                  <span
                    key={t}
                    className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900"
                  >
                    {t}
                  </span>
                ))}
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700">{current.intro}</p>
              <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <p className="text-sm font-semibold text-primary-600">{current.latestChapter}</p>
                  <p className="mt-0.5 text-xs text-foreground-500">
                    更新于 {current.updateTime}
                  </p>
                </div>
                <a
                  href="#updates"
                  className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  直达最新话
                </a>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}